import { render, staticRenderFns } from "./sourceDetail.vue?vue&type=template&id=6455850c&scoped=true&"
import script from "./sourceDetail.vue?vue&type=script&lang=js&"
export * from "./sourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./sourceDetail.vue?vue&type=style&index=0&id=6455850c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455850c",
  null
  
)

export default component.exports